module.exports = __webpack_public_path__ + "assets/img/3b1821d31ef39c4a757f93b23230ce5d.svg";